export default __webpack_public_path__ + "static/chart-customisation-7392318eaa9cb81742f2946471d42b0c.png";